'use client';
import React, { useEffect, useRef, useState } from 'react';
import data from '../../../data/innerpages/portfolio/latestcases';
import mixitup from 'mixitup';
import { Link } from 'react-router-dom';
function LatestCases() {
  const [activeFilter, setActiveFilter] = useState('All');
  const mixitupContainerRef = useRef(null);

  useEffect(() => {
    const initializeMixitup = () => {
      mixitup(mixitupContainerRef.current, {
        load: {
          sort: 'order:asc',
        },
        animation: {
          duration: 700,
        },
        classNames: {
          block: 'filter',
          elementFilter: 'filter-btn',
          elementSort: 'sort-btn',
        },
        selectors: {
          target: '.mix-item',
        },
      });
    };

    initializeMixitup();
  }, []);
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);

    // Remove 'active' class from all filter buttons
    document.querySelectorAll('.filter-btn').forEach((btn) => {
      btn.classList.remove('active');
    });

    // Add 'active' class to the clicked filter button, if it exists
    const clickedButton = document.querySelector(`[data-filter="${filter}"]`);
    if (clickedButton) {
      clickedButton.classList.add('active');
    }
  };

  return (
    <section className="tc-latest-cases-style1">
      <div className="container">
        <div className="content">
          <h3 className="fsz-45 text-capitalize mb-50 db-color ">
            Latest Cases
          </h3>
          <div className="cases">
            <div
              className="filter mb-60 wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              <div className="links">
                <a
                  onClick={() => handleFilterClick('All')}
                  className={`filter-btn ${
                    activeFilter === 'All' ? 'active' : ''
                  }`}
                  href="#0"
                  data-filter="*"
                >
                  All
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Institutional')}
                  className={`filter-btn ${
                    activeFilter === 'Institutional' ? 'active' : ''
                  }`}
                  data-filter=".Institutional"
                >
                  Institutional
                </a>
                {/* <a
                  href="#0"
                  onClick={() => handleFilterClick('Retails')}
                  className={`filter-btn ${
                    activeFilter === 'Retails' ? 'active' : ''
                  }`}
                  data-filter=".Retails"
                >
                  Retails
                </a> */}
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Office')}
                  className={`filter-btn ${
                    activeFilter === 'Office' ? 'active' : ''
                  }`}
                  data-filter=".Office"
                >
                  Office
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Homes')}
                  className={`filter-btn ${
                    activeFilter === 'Homes' ? 'active' : ''
                  }`}
                  data-filter=".Homes"
                >
                  Home
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Housing')}
                  className={`filter-btn ${
                    activeFilter === 'Housing' ? 'active' : ''
                  }`}
                  data-filter=".Housing"
                >
                  Housing
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('FarmHouse')}
                  className={`filter-btn ${
                    activeFilter === 'FarmHouse' ? 'active' : ''
                  }`}
                  data-filter=".FarmHouse"
                >
                  Farm House
                </a>
                <a
                  href="#0"
                  onClick={() => handleFilterClick('Club')}
                  className={`filter-btn ${
                    activeFilter === 'Club' ? 'active' : ''
                  }`}
                  data-filter=".Club"
                >
                  Club
                </a>
                {/* <a
                  href="#0"
                  onClick={() => handleFilterClick('Designs')}
                  className={`filter-btn ${
                    activeFilter === 'Designs' ? 'active' : ''
                  }`}
                  data-filter=".Designs"
                >
                  Designs
                </a> */}
              </div>
            </div>
            <div
              className="cases-content wow fadeInUp slow"
              data-wow-delay="0.4s"
            >
              <div className="row mixitup" ref={mixitupContainerRef}>
                {data.map((item, i) => (
                  <div key={i} className={`col-lg-4 mix-item ${item.subTitle}`}>
                    <div className="case-card">
                      <div className="img">
  <img src={item.img} alt="" className="img-cover" />
</div>
                      <div className="info">
                        <div className="tags mb-30">
                          <a href="#"> {item.subTitle.split('<br />')[0]} </a>
                          {item.subTitle.split('<br />')[1] && (
                            <a href="#"> {item.subTitle.split('<br />')[1]} </a>
                          )}
                        </div>
                       <h3 className="title fsz-35 mb-20">
  <Link
    to={`/innerpages/single_project/${item.slug}`}
    style={{ color: "#ffcd00", backgroundColor: "rgba(0,0,0,0.4)" }} 
  >
    {item.title}
  </Link>
</h3>
                        <div className="text color-666">
                          {item.desc.split('<br />')[0]}
                          <br /> {item.desc.split('<br />')[1]}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* <nav aria-label="Page navigation example">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="fal fa-chevron-left"></i>
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link active" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      ...
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      15
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="fal fa-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestCases;
